import { render } from "./Internacional.vue?vue&type=template&id=2f131398"
import script from "./Internacional.vue?vue&type=script&lang=js"
export * from "./Internacional.vue?vue&type=script&lang=js"

import "./Internacional.vue?vue&type=style&index=0&id=2f131398&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__